import { ROUTE_ADMIN } from '~/contexts/admin-tenant/router/routes'
import { ROUTE_CALLS } from '~/contexts/calls/router/routes'
import { ROUTE_COMMUNITY } from '~/contexts/community/router/routes'
import { ROUTE_DM } from '~/contexts/dm/router/routes'
import { ROUTE_HOME } from '~/contexts/home/router/routes'
import { ROUTE_ME } from '~/contexts/me/router/routes'
import { ROUTE_NETWORK } from '~/contexts/network/router/routes'
import { ROUTE_NOTIFICATION } from '~/contexts/notification/router/routes'
import { ROUTE_RITUAL } from '~/contexts/ritual/router/routes'

import { EProfile } from '~/entities/user/user/interfaces/user'

import { ENetworkActivity as ENetworkActivityContext } from '~/features-swym/network-activity/interfaces/network-activity'

import { MediaModel } from '~/features-shared/content/interfaces/content'
import { IContentModel } from '~/features-shared/content/interfaces/content-model'

export enum EContext {
  NULL,
  COMMUNITY,
  DM,
  CALLS,
  RITUALS,
  CONTACTS,
  ME,
  NOTIFICATIONS,
  NETWORK,
  ADMIN,
  APPUPDATE,
  AURA,
  ERROR,
}

export enum IContentContext {
  All = 'all',
  Community = 'community',
  Message = 'message',
  Comment = 'comment',
  MyUniverse = 'myUniverse',
  GlobalNetwork = 'globalNetwork',
  AdminControl = 'adminControl',
  ContentReader = 'contentReader',
  Rituals = 'conferencetemplate',
  Answer = 'answer',
}
export enum EMeContext {
  GlobalDraft = 'drafts',
  MeActivity = 'me-activity',
  Bookmark = 'bookmarks',
  Contributions = 'contributions',
  PersonalSpace = 'personal-space',
  RecycleBin = 'recycle-bin',
}

export enum ICommunityExplore {
  CommunityExplore = 'communityExplore',
}

export const EContentContext = {
  ...IContentContext,
  ...IContentModel,
  ...EMeContext,
  ...ENetworkActivityContext,
  ...ICommunityExplore,
  ...EProfile,
  ...MediaModel,
}
// TODO : add user ?
type ValueOf<T> = T extends any[] ? T[number] : T[keyof T]
export type TContentContext = ValueOf<typeof EContentContext>

/**
 * Page context Enum and Type
 */
export const IPageContext = Object.freeze({

  AdminTenant: ROUTE_ADMIN.ADMIN_TENANT,

  Calls: ROUTE_CALLS.HOME,

  Home: ROUTE_HOME.HOME,
  HomeFavorites: ROUTE_HOME.HOME_FAVORITES,
  CommunityFeed: ROUTE_COMMUNITY.URI_HOME,
  CommunityFiltered: ROUTE_COMMUNITY.URI_FACETS_CONTENT, // POST/MEDIA/IDEA/QUESTION/WIKI/WEDO/SURVEY/CONFERENCE/DT-IDEA/DT-POST
  CommunityMembers: ROUTE_COMMUNITY.URI_MEMBERS,
  CommunitySettings: ROUTE_COMMUNITY.URI_SETTINGS,
  CommunityReports: ROUTE_COMMUNITY.URI_REPORTS,
  CommunityStatistics: ROUTE_COMMUNITY.URI_STATISTICS,
  CommunityExplore: ROUTE_COMMUNITY.EXPLORE,

  DmTimeline: ROUTE_DM.URI_HOME,
  DmFiltered: ROUTE_DM.URI_FACETS_CONTENT, // POST/MEDIA/IDEA/QUESTION/WIKI/WEDO/SURVEY/CONFERENCE/DT-IDEA/DT-POST
  DmMembers: ROUTE_DM.URI_MEMBERS,

  MeBookmarks: ROUTE_ME.BOOKMARKS,
  MePersonalSpace: ROUTE_ME.PERSONAL_SPACE_HOME,
  MeActivity: ROUTE_ME.ACTIVITY_HOME,
  MeActivityFiltered: ROUTE_ME.ACTIVITY_CONTENT_TYPE,
  MeContributions: ROUTE_ME.CONTRIBUTIONS_HOME,
  MeContributionsFiltered: ROUTE_ME.CONTRIBUTIONS_CONTENT_TYPE, // POST/MEDIA/IDEA/QUESTION/WIKI/WEDO/SURVEY/CONFERENCE/DT-IDEA/DT-POST
  MeDrafts: ROUTE_ME.DRAFTS_HOME,
  MeDraftsFiltered: ROUTE_ME.DRAFTS_CONTENT_TYPE,
  MePreferences: ROUTE_ME.PREFERENCES,
  MeProfile: ROUTE_ME.PROFILE_HOME,
  MeSecurity: ROUTE_ME.SECURITY,
  MeOrganization: ROUTE_ME.ORGANIZATION,

  Network: ROUTE_NETWORK.ACTIVITY,
  NetworkInvitations: ROUTE_NETWORK.INVITATIONS,
  NetworkUser: ROUTE_NETWORK.USER_HOME,
  NetworkUserActivity: ROUTE_NETWORK.USER_ACTIVITY,
  NetworkUserNetwork: ROUTE_NETWORK.USER_NETWORK,
  NetworkUserProfile: ROUTE_NETWORK.USER_PROFILE,

  Notifications: ROUTE_NOTIFICATION.HOME,

  Rituals: ROUTE_RITUAL.HOME,
  RitualsThread: ROUTE_RITUAL.URI_HOME,
  RitualsSchedule: ROUTE_RITUAL.SCHEDULE,
  RitualsScheduleThread: ROUTE_RITUAL.URI_SCHEDULE,
})
